module.exports = __webpack_public_path__ + "static/media/game-speech-sound.e43ce0ad.mp3";